export enum ScoreTypeEnum {
    ForloebEvalueringScore = 1,
    KompetenceEvalueringScore = 2
}
